<template>
<!--    <el-container style="height: calc(100vh)">-->
<!--      <el-aside width="250px" >-->
<!--      </el-aside>-->
<!--      <el-main >-->
<!--        <h1 style="text-align: center">{{data.title}}</h1>-->
<!--        <div v-html="data.content" style="padding: 30px"></div>-->
<!--      </el-main>-->
<!--      <el-aside width="250px" >-->
<!--        <div  style="font-size: 16px;position: absolute;top: 130px; " v-if="glData.length > 0">关联产品如下({{glData.length}}):</div>-->
<!--        <el-scrollbar style="position: absolute;top: 150px; height: 85vh; width: 250px">-->
<!--        <el-col span="24" v-for="(item,index) in glData" :key="index" >-->
<!--          <el-link type="primary" @click="toProductDetail(item.bglId)">{{item.bglName}}</el-link>-->
<!--        </el-col>-->
<!--        </el-scrollbar>-->
<!--      </el-aside>-->
<!--    </el-container>-->
    <div class="container">
        <el-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20" style="padding-right: 20px">
            <h1 style="text-align: center">{{data.title}}</h1>
            <el-scrollbar class="containerLeft">
              <a :href="data.content" :title="data.content" target="_blank" style="color: cornflowerblue" v-if="data.contentType=='1'||data.contentType=='3'">{{data.title}}</a>
              <div v-else v-html="data.content" ></div>
            </el-scrollbar>
        </el-col>
        <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
            <div style="position: relative">
                <div style="font-size: 16px;padding-top: 20px" v-if="glData.length > 0">关联产品如下({{glData.length}}):</div>
                <el-scrollbar  class="containerRight">
                  <el-col span="24" v-for="(item,index) in glData" :key="index" >
                    <el-link type="primary" @click="toProductDetail(item.bglId)">{{item.bglName}}</el-link>
                  </el-col>
                </el-scrollbar>
            </div>
        </el-col>
    </div>
</template>

<script>
  import { getDetail} from "@/api/cr/zsk/zsk";
  import {getAllList} from "@/api/cr/tygl/tyglb";
//转发知识库详情
    export default {
      name: "zfZskDetail",
      data() {
        return {
          data:'',
          glData:[]
        }
      },
      created() {
        if(this.$route.query.id){
          console.log(this.$route.query.id,"请求参数");
          let id = this.$route.query.id;
          getDetail(id).then(res=>{
            if(res.data.msg == "暂无承载数据"){
              document.title="此数据已删除";
              this.$message.warning("此数据已删除");
              return false;
            }
            this.data = res.data.data;
            document.title=this.data.title;
          });
          //查询关联产品
          getAllList({glId:id,gllx:'1'}).then(res=>{
            this.glData = res.data.data;
          })
        }
      },
      methods: {
        toProductDetail(id){
          window.open("/h5/productdetail?id="+id)
        }
      }

    }
</script>

<style scoped lang="scss">
  .container{
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 30px;
    height: 100vh;
  }
  @media screen and (min-width:768px) {
    .containerLeft {
      height: calc(100vh - 150px);
      overflow: auto;
    }
    .containerRight {
      position: absolute;
      top: 60px;
      height: calc(100vh);
      overflow-y: auto;
      overflow-x: hidden;
    }
  }
  .cube_drawer ::v-deep .el-drawer__body {
      padding: 0!important;
  }
  @media screen and (max-width:768px){
    .container{
      overflow-y: auto;
    }
    .containerLeft{
      height: auto;
    }
    .containerRight{
      height: auto;
    }
  }
</style>
